var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.821314 1.15497C0.508862 1.46752 0.333336 1.89136 0.333336 2.3333C0.333336 2.77524 0.508862 3.19909 0.821314 3.51164L11.3096 14L0.821314 24.4883C0.66213 24.642 0.535159 24.826 0.447811 25.0293C0.360462 25.2326 0.314486 25.4513 0.312563 25.6726C0.31064 25.8939 0.35281 26.1134 0.436611 26.3182C0.520413 26.523 0.644168 26.7091 0.800656 26.8656C0.957144 27.0221 1.14323 27.1459 1.34806 27.2297C1.55288 27.3135 1.77235 27.3556 1.99365 27.3537C2.21495 27.3518 2.43365 27.3058 2.63699 27.2185C2.84033 27.1311 3.02424 27.0042 3.17798 26.845L14.8446 15.1783C15.1571 14.8658 15.3326 14.4419 15.3326 14C15.3326 13.558 15.1571 13.1342 14.8446 12.8216L3.17798 1.15497C2.86543 0.842518 2.44159 0.666992 1.99965 0.666992C1.55771 0.666992 1.13386 0.842518 0.821314 1.15497V1.15497Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.54288d688c3f2e738aa4a8415b4474ac.svg";
export { ForwardRef as ReactComponent };